import api from "./api";

export const Login = async (userData) => {
  const response = await api.post("/login", userData, {
    withCredentials: true,
  });
  return response.data;
};

export const Logout = async () => {
  const response = await api.post("/logout", {}, { withCredentials: true });
  return response.data;
};

export const verify = async () => {
  try {
    const { data } = await api.get("/verify", {
      withCredentials: true,
      headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
      params: { t: Date.now() },
    });
    return data; // expected { user: {...} }
  } catch (err) {
    // If not authenticated -> treat as guest, don't explode
    if (err.response && err.response.status === 401) {
      return null; // no user
    }

    // Other errors (500, CORS, network) you DO want to know about
    console.error("Verify request failed:", err);
    throw err;
  }
};
